<template>
  <div>
    <h3 class="subtitle">{{ $t("absence.absenceCalendar") }}</h3>
    <table class="table is-fullwidth is-narrow">
      <tr> 
        <th></th>         
        <th></th>         
        <th v-for="week in period" v-bind:key="week" class="week-column">
          <span v-if="week == currentWeek" class="tag is-info">{{ week }}</span>
          <span v-else>{{ week }}</span>
        </th>
      </tr>
      <tr v-for="user in approverFor" v-bind:key="user['.key']">
        <th>{{ returnUserName(user['.key']) }}</th>
        <th>&nbsp;</th>
        <td v-for="week in period" v-bind:key="week" class="is-centered">
            <div class="absence-element"
              v-for="absence in userAbsence(user['.key'])" 
              v-if="isDateInWeek(absence.fromDate, absence.toDate, week) > 0" 
              v-bind:key="absence['.key']">
                <!-- no: {{noOfWeeks(absence.fromDate, absence.toDate)}} date: {{isDateInWeek(absence.fromDate, absence.toDate, week)}} -->
                <span class="tag tag-left" v-bind:class="[{'is-success': absence.isApproved}, {'tag-inactive': !absence.sentForApproval}]" v-if="noOfWeeks(absence.fromDate, absence.toDate) > 1 && isDateInWeek(absence.fromDate, absence.toDate, week) == 1">&nbsp;</span>
                <span class="tag tag-left absolute-left-tag" v-bind:class="[{'is-success': absence.isApproved}, {'tag-inactive': !absence.sentForApproval}]" v-if="noOfWeeks(absence.fromDate, absence.toDate) == 1 && isDateInWeek(absence.fromDate, absence.toDate, week) == 1">{{absence.absence}}</span>
                <span class="tag tag-middle" v-bind:class="[{'is-success': absence.isApproved}, {'tag-inactive': !absence.sentForApproval}]" v-if="noOfWeeks(absence.fromDate, absence.toDate) > 1 && isDateInWeek(absence.fromDate, absence.toDate, week) == 3">{{absence.absence}}</span>
                <span class="tag tag-right" v-bind:class="[{'is-success': absence.isApproved}, {'tag-inactive': !absence.sentForApproval}]" v-if="noOfWeeks(absence.fromDate, absence.toDate) >= 1 && isDateInWeek(absence.fromDate, absence.toDate, week) == 2">&nbsp;</span>
            </div>
            <div
              v-for="absence in userAbsence(user['.key'])" 
              v-if="isDateInWeek(absence.fromDate, absence.toDate, week) == 0" 
              v-bind:key="absence['.key']">
                <!-- no: {{noOfWeeks(absence.fromDate, absence.toDate)}} date: {{isDateInWeek(absence.fromDate, absence.toDate, week)}} -->
                <span class="tag tag-single" v-bind:class="[{'is-success': absence.isApproved}, {'tag-inactive': !absence.sentForApproval}]">{{ absence.absence }}</span>
            </div>
        </td>
      </tr>
    </table>
    <!-- <div class="columns is-gapless">
      <div class="column is-narrow"> <div style="width:100px"></div></div>
      <div class="column is-centered" v-for="week in period" v-bind:key="week">
        <span v-if="week == currentWeek" class="tag is-info">{{ week }}</span>
        <span v-else>{{ week }}</span>
      </div>
    </div>
      <div class="columns is-gapless" v-for="user in approverFor" v-bind:key="user['.key']">
        <div class="column is-narrow">
          <div style="width:100px">{{ returnUserName(user['.key']) }}</div>
        </div>
        <div class="column is-centered" v-for="week in period" v-bind:key="week">
          <span class="tag" 
            v-for="absence in userAbsence(user['.key'])" 
            v-if="isDateInWeek(absence.fromDate, absence.toDate, week) > 0" 
            v-bind:key="absence['.key']">
              {{absence.absence}}
          </span>
        </div>
      </div>-->
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AbsenceCalendar',
  components: {
      Multiselect
    },
  props: {
  },
  data: function() {
      return {
        currentWeek: moment().isoWeek(),
        weeksInYear: moment().isoWeeksInYear()
      }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        absence: {
            // FIXME: add filtering so only sentForAproval == true are fetched 
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsAbsence/'),
            asObject: true,
        },
        approverFor: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users/' + userid + '/adminCanEdit/approverFor/'),
            asObject: false,
            cancelCallback: function () {},
            readyCallback: function () {}
        },
        orgUsers: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users').orderByChild('adminCanEdit/active').equalTo(true),
            asObject: false,
        },
    }
  },
  
  computed: {
    startOfPeriod(){
      return moment().isoWeek(this.currentWeek).subtract(4, 'weeks').format('W')      
    }, 
    endOfPeriod() {
      return moment().isoWeek(this.currentWeek).add(10, 'weeks').format('W') 
    },
    period() {
        const startWeek = Number(this.startOfPeriod);
        const endWeek = Number(this.endOfPeriod)
        const noWeeks = Number(this.weeksInYear
        )
        if(endWeek > startWeek) {
          let weeks = [];
          for (var i = startWeek; i <= endWeek; i++) {
            weeks.push(i);
          }
          return weeks;
        } else {
          let weeksBefore = [];
          let weeksAfter = [];
          for (var i = startWeek; i <= noWeeks; i++) {
            weeksBefore.push(i);
          }
          for (var i = 1; i <= endWeek; i++) {
            weeksAfter.push(i);
          }
          return _.concat(weeksBefore, weeksAfter)
        }
    }
  },
  methods: {
    noOfWeeks(dateFrom, dateTo) {
      return moment(dateTo).isoWeek() - moment(dateFrom).isoWeek()
    },
    isDateInWeek(dateFrom, dateTo, week) {
      // from and to are in the same current week 
      if(moment(dateFrom).isoWeek() == week && moment(dateTo).isoWeek() == week) {
        return 0
      } else {
        // date is where absence stops
        if(moment(dateFrom).isoWeek() < week && moment(dateTo).isoWeek() == week) {
          return 2
        } else {
          // to date is in the future
          if(moment(dateFrom).isoWeek() == week && moment(dateTo).isoWeek() > week) {
            return 1
          } else {
              if(moment(dateFrom).isoWeek() < week && moment(dateTo).isoWeek() > week) {
              return 3
            } else {
                if(moment(dateTo).isoWeek() > week) {
                  return -1
                }
            }
          }
        }
        return -1
      }
    },
    userAbsence(uid) {
      return _.orderBy(this.absence[uid], ['toDate'], ['desc']) || []
    },
    returnUserName(uid) {
          return _.get(_.find(this.orgUsers, {'.key': uid}), 'userCanEdit.name')
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  table-layout:fixed!important;
}
table td {
  width: 35px!important;
}
.is-centered {
  text-align: center;
}
.table.is-narrow td {
    padding: 0;
}
.tag {
  width: 100%;
  flex-direction: column;
}
.tag-left {
  border-top-right-radius: 0!important;
  border-bottom-right-radius: 0!important;
}
.tag-middle {
  border-radius: 0!important;
  border-radius: 0!important;
}
.tag-right {
  border-top-left-radius: 0!important;
  border-bottom-left-radius: 0!important;
}
.absence-element {
  position: relative;
}
.absolute-left-tag {
  position: absolute!important; 
  right: 0!important; 
  z-index:100!important; 
  padding-left:50px!important; 
  margin-top: 1.3px!important;
}
.tag-inactive {
  background:url(
    data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAGklEQVQYlWNgIAD+////n6ACvIpGiAIGBgYAhApDvTGbJVcAAAAASUVORK5CYII=
   ) repeat;
}
</style>
